import React from 'react';
import { MenuItem } from '@mui/material';
import { t } from 'i18next';
import { CustomSelectAndChildren } from '../../../../components/CustomSelectAndChildren';
import { CustomCheckbox } from '../../../../components/CustomCheckbox';
import CustomDateTimePicker from '../../../../components/CustomDateTimePicker';
import DividerWithText from '../../../../components/DividerWithText';
import { CONTROLLER_TIME_ZONES } from "./Model/Models";

/**
 * Time zone section of the controller form: the time zone (utcOffsetMinutes) and the daylight saving time.
 * The daylight saving start and end are required only while the daylight saving time is enabled, and are cleared when it is disabled.
 */
const TimeZoneController = ({ controller, handleChange, emptyFields, disabled }) => {

    return (
        <div className='row'>
            <div className={"col-12 mb-4"}>
                <DividerWithText title={t('time_zone')} />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomSelectAndChildren
                    id={"slt_tzc_time_zone"}
                    disabled={disabled}
                    name={"utcOffsetMinutes"}
                    trans={"time_zone"}
                    value={controller.utcOffsetMinutes ?? ''}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    showNoSelectionOption={false}
                >
                    {CONTROLLER_TIME_ZONES.map((item) => (
                        <MenuItem key={item.utcOffsetMinutes} value={item.utcOffsetMinutes}>
                            {t(item.name)}
                        </MenuItem>
                    ))}
                </CustomSelectAndChildren>
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomCheckbox
                    id={"cb_tzc_daylight_saving_enabled"}
                    name={"daylightSavingEnabled"}
                    trans={"daylight_saving_time"}
                    checked={controller.daylightSavingEnabled}
                    onChange={(e) => {
                        // MUI sends the checked flag as the second argument, which handleChange would take as the field name
                        handleChange(e);
                        if (!e.target.checked) {
                            handleChange({ target: { name: 'daylightSavingStart', value: null } });
                            handleChange({ target: { name: 'daylightSavingEnd', value: null } });
                        }
                    }}
                    disabled={disabled}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomDateTimePicker
                    id={"dtp_tzc_daylight_saving_start"}
                    name={"daylightSavingStart"}
                    trans={"daylight_saving_start"}
                    value={controller.daylightSavingStart}
                    onChange={(value) => handleChange({ target: { name: 'daylightSavingStart', value } })}
                    disabled={disabled || !controller.daylightSavingEnabled}
                    required={controller.daylightSavingEnabled}
                    emptyFields={emptyFields && controller.daylightSavingEnabled}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomDateTimePicker
                    id={"dtp_tzc_daylight_saving_end"}
                    name={"daylightSavingEnd"}
                    trans={"daylight_saving_end"}
                    value={controller.daylightSavingEnd}
                    onChange={(value) => handleChange({ target: { name: 'daylightSavingEnd', value } })}
                    disabled={disabled || !controller.daylightSavingEnabled}
                    required={controller.daylightSavingEnabled}
                    emptyFields={emptyFields && controller.daylightSavingEnabled}
                    isValid={controller.isValidDaylightSavingRange()}
                    isValidText={"end_date_cannot_be_before_or_equal_start_date"}
                />
            </div>
        </div>
    );
};

export default TimeZoneController;
